'use strict';

const { grecaptchaGenerateToken } = require('../common/grecaptchaUtils');

$(document).ready(() => {
    const $form = $('.video-call-form');
    let scheduledData = null;
    let formSubmitted = false;
    let isRescheduling = false;
    let currentAppointmentId = null;

    /**
     * Resets the video call modal to its initial state.
     */
    function resetModalToInitialState() {
        $('.call-scheduler').addClass('d-none').hide();
        $('.first-section').show();
        $('.confirm-call-schedule').addClass('d-none').hide();
        $('#available-time-field').val('');
        $('#selected-date-field').val('');
        $('.available-time-options ul').empty();
        $('#datesContainer').empty();
        $('#timeSlotDropdown').empty();
        $('.date.selected').removeClass('selected');
        $('.available-time-options').hide();
        $('.available-time-dropdown').removeClass('rotate');
    }

    /**
 * Resets the rescheduling state variables.
 * Assumes `isRescheduling` and `currentAppointmentId` are declared in outer scope.
 */
    function resetRescheduleState() {
        isRescheduling = false;
        currentAppointmentId = null;
    }

    /**
 * Manually removes Bootstrap modal backdrop and resets body styles.
 */
    function removeModalBackdrop() {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('body').css({
            'padding-right': '',
            overflow: ''
        });
        $('#videoCallModel').removeClass('show').attr('aria-hidden', 'true');
    }

    /**
 * Programmatically closes the video call modal and resets all modal-related states.
 */
    function forceCloseModal() {
        $('#videoCallModel').modal('hide');

        setTimeout(() => {
            removeModalBackdrop();
            resetModalToInitialState();
            resetRescheduleState();
        }, 300);
    }

    /**
 * Formats a JavaScript Date object into a 12-hour time string for the 'en-IN' locale.
 * @param {Date} date - A valid JavaScript Date object.
 * @returns {string} - The formatted time string in HH:MM AM/PM format.
 */
    function formatTime(date) {
        return date.toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).toUpperCase();
    }

    /**
 * Rounds a Date up to the next 15-minute boundary.
 * If the date is already exactly on a 15-minute boundary, returns the same time.
 * @param {Date} date - The date to round up.
 * @returns {Date} - The rounded date.
 */
    function roundUpToNextQuarter(date) {
        const d = new Date(date);
        d.setSeconds(0, 0);
        const minutes = d.getMinutes();
        const rem = minutes % 15;
        if (rem === 0) return d;
        d.setMinutes(minutes + (15 - rem));
        return d;
    }

    /**
     * Populates available time slots in custom dropdown and native select.
     */
    function populateCustomTimeSlots() {
        const ul = $('.available-time-options ul');
        const nativeSelect = $('#timeSlotDropdown');
        const inputField = $('#available-time-field');
        const dropdown = $('.available-time-options');
        const arrow = $('#career-salutation-dropdown');

        ul.empty();
        nativeSelect.empty();

        // Use selected date (if any) as base for slots, otherwise today
        const selectedDateVal = $('#selected-date-field').val();
        const baseDate = selectedDateVal ? new Date(selectedDateVal + 'T00:00:00') : new Date();

        const start = new Date(baseDate);
        start.setHours(10, 0, 0, 0);
        const endLimit = new Date(baseDate);
        endLimit.setHours(19, 0, 0, 0);

        // If selected date is today, calculate minimum allowed slot start
        const todayISO = new Date().toISOString().split('T')[0];
        const isToday = selectedDateVal ? (selectedDateVal === todayISO) : (start.toISOString().split('T')[0] === todayISO);
        const now = new Date();
        const minStartForToday = isToday ? roundUpToNextQuarter(now) : null;

        // If a non-today date is explicitly selected, force the default to the first slot (10:00 AM)
        const forceSelectFirst = selectedDateVal && !isToday;
        if (forceSelectFirst) {
            // clear any previously selected value so the loop will pick the first non-disabled slot
            inputField.val('');
        }

        let firstSlotSet = false;

        while (start < endLimit) {
            const end = new Date(start.getTime() + 15 * 60000);
            const slotText = `${formatTime(start)} - ${formatTime(end)}`;

            const option = $('<option></option>').val(slotText).text(slotText);

            // Determine if this slot should be disabled (for today and before current time)
            let disabled = false;
            if (isToday && minStartForToday) {
                const slotStart = new Date(start.getTime());
                if (slotStart < minStartForToday) {
                    disabled = true;
                }
            }

            if (disabled) {
                option.addClass('d-none');
            }

            nativeSelect.append(option);

            const li = $('<li tabindex="-1" class="available-time-option"></li>')
                .attr('data-value', slotText)
                .html(`<span>${slotText}</span>`);

            if (disabled) {
                li.addClass('d-none');
            }

            if (inputField.val() === slotText) {
                // If the currently set input matches a disabled slot, clear it so we pick a valid one
                if (disabled) {
                    inputField.val('');
                } else {
                    li.addClass('selected');
                    option.prop('selected', true);
                }
            }

            if ((!firstSlotSet && !inputField.val() && !disabled) || (!firstSlotSet && forceSelectFirst && !disabled)) {
                inputField.val(slotText);
                li.addClass('selected');
                option.prop('selected', true);
                firstSlotSet = true;
            }

            li.on('click', (e) => {
                e.stopPropagation();
                if (li.hasClass('disabled')) return;
                ul.find('li.selected').removeClass('selected');
                li.addClass('selected');
                inputField.val(slotText);
                nativeSelect.val(slotText);
                dropdown.hide();
                arrow.removeClass('rotate');
            });

            ul.append(li);
            start.setTime(end.getTime());
        }
    }

    /**
     * Formats a date string into a user-friendly display format.
     * @param {string} dateString - ISO date string.
     * @returns {string} - Formatted display date.
     */
    function formatDisplayDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
    }

    $('.social-share-close').on('click', function () {
        $('#socialShareModel').modal('hide');
    });

    /**
     * Initializes the date carousel and date selection behavior.
     */
    function initScheduler() {
        const datesContainer = document.getElementById('datesContainer');
        if (!datesContainer) return;
        datesContainer.innerHTML = '';

        const today = new Date();
        const now = new Date();

        for (let i = 0; i < 14; i += 1) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);

            // If today has no remaining slots, skip adding today's date
            var addDate = true;
            if (i === 0) {
                const dayEnd = new Date(date);
                dayEnd.setHours(19, 0, 0, 0);
                const minStartForToday = roundUpToNextQuarter(now);
                if (minStartForToday >= dayEnd) {
                    addDate = false;
                }
            }

            if (!addDate) {
                // Skip rendering today's date when there are no remaining slots
            } else {
                const btn = document.createElement('div');
                btn.className = 'date';
                btn.innerHTML = `
                    <div class="initial">${date.toLocaleDateString('en-US', { weekday: 'short' }).charAt(0)}</div>
                    <div class="date-number">${date.getDate()}</div>
                    <div class="initial">${date.toLocaleDateString('en-US', { month: 'short' })}</div>`;
                btn.dataset.date = date.toISOString().split('T')[0];

                btn.onclick = () => {
                    document.querySelectorAll('.date').forEach(el => el.classList.remove('selected'));
                    btn.classList.add('selected');
                    // Set selected date BEFORE populating slots so populateCustomTimeSlots
                    // can correctly detect whether the selected date is today.
                    document.getElementById('selected-date-field').value = btn.dataset.date;
                    populateCustomTimeSlots();
                };

                datesContainer.appendChild(btn);
            }
        }

        // If no date was pre-selected (e.g., we skipped today), select the first available
        const firstBtn = datesContainer.querySelector('.date');
        if (firstBtn && !datesContainer.querySelector('.date.selected')) {
            firstBtn.classList.add('selected');
            document.getElementById('selected-date-field').value = firstBtn.dataset.date;
            populateCustomTimeSlots();
        }

        const navLeft = document.querySelector('.nav.left');
        const navRight = document.querySelector('.nav.right');

        if (navLeft && navRight) {
            navLeft.onclick = () => datesContainer.scrollBy({ left: -100, behavior: 'smooth' });
            navRight.onclick = () => datesContainer.scrollBy({ left: 100, behavior: 'smooth' });
        }
    }

    /**
 * Handles logic when the video call modal is closed.
 *
 * Assumes `formSubmitted` and `scheduledData` are defined in the outer scope.
 */
    function handleModalClose() {
        if (formSubmitted && scheduledData) {
            $('.video-reschedule-banner .scheduled-date-time').text(scheduledData.dateTime);
            $('.video-reschedule-banner .reschedule-btn').attr('data-id', scheduledData.id);
            $('.video-reschedule-banner').removeClass('d-none').show();
            $('.vc-section-right').addClass('d-none');
            $('.video-call-gif').addClass('d-none');
            formSubmitted = false;
        }
    }

    const timeZoneDisplay = document.getElementById('time-zone-display');
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
        const offset = new Date().toLocaleTimeString('en-us', {
            timeZone: userTimeZone,
            timeZoneName: 'short'
        }).split(' ').pop();

        if (timeZoneDisplay) {
            timeZoneDisplay.textContent = `${userTimeZone.replace('_', ' ')} (${offset})`;
        }
    } catch (e) {
        if (timeZoneDisplay) {
            timeZoneDisplay.textContent = 'Unknown';
        }
    }

    $('#videoCallModel').on('shown.bs.modal', function () {
        $(this).removeClass('fade').addClass('show');
    });

    $('#videoCallModel').on('hidden.bs.modal', function () {
        resetModalToInitialState();
        resetRescheduleState();
        handleModalClose();

        setTimeout(() => {
            removeModalBackdrop();
        }, 100);
    });

    $('#videoCallModel').on('click', function (e) {
        if (e.target === this || $(e.target).hasClass('modal-backdrop')) {
            forceCloseModal();
        }
    });

    $(document).on('click', '.reschedule-btn', function (e) {
        e.preventDefault();

        const appointmentId = $(this).attr('data-id');
        isRescheduling = true;
        currentAppointmentId = appointmentId;

        removeModalBackdrop();

        $('.call-scheduler').addClass('d-none').hide();
        $('.first-section').hide();
        $('.confirm-call-schedule').addClass('d-none').hide();
        $('#available-time-field').val('');
        $('#selected-date-field').val('');
        $('.available-time-options ul').empty();
        $('#datesContainer').empty();
        $('#timeSlotDropdown').empty();
        $('.date.selected').removeClass('selected');
        $('.available-time-options').hide();
        $('.available-time-dropdown').removeClass('rotate');

        $('.call-scheduler').removeClass('d-none').show();
        $('.modal-title.video-call-section-title').text('Reschedule Meeting');

        initScheduler();

        setTimeout(() => {
            $('#videoCallModel').modal('show');
        }, 100);
    });

    $('.continue-shopping-btn, .close').on('click', function (e) {
        e.preventDefault();
        forceCloseModal();
        $('.modal-title.video-call-section-title').text('Schedule Meeting');
    });

    $('.first-section-btn').on('click', (e) => {
        e.preventDefault();
        $('.first-section').hide();
        $('.call-scheduler').removeClass('d-none').show();
        initScheduler();
    });

    const container = $('.available-select-div');
    const dropdown = $('.available-time-options');
    const arrow = $('#career-salutation-dropdown');

    container.on('click', (e) => {
        e.stopPropagation();
        $('.available-time-options').not(dropdown).hide();
        $('.available-time-dropdown').not(arrow).removeClass('rotate');
        dropdown.toggle();
        arrow.toggleClass('rotate', dropdown.is(':visible'));
    });

    $(document).on('click', () => {
        if (dropdown.is(':visible')) {
            dropdown.hide();
            arrow.removeClass('rotate');
        }
    });

    $('.close').on('click', function (e) {
        e.preventDefault();
        $('#videoCallModel').modal('hide');
    });

    /**
     * Handles form submission via AJAX and updates confirmation section.
     */
    $form.on('submit', async function (e) {
        e.preventDefault();
        let url;
        let submitData;

        if (isRescheduling && currentAppointmentId) {
            url = $('.reschedule-btn').data('url');
            submitData = $.param({
                accountId: currentAppointmentId,
                date: $('#selected-date-field').val(),
                time: $('#available-time-field').val(),
                recaptchaToken: await grecaptchaGenerateToken()
            });
        } else {
            url = $form.attr('action');
            submitData = $form.serialize() + '&recaptchaToken=' + await grecaptchaGenerateToken();
        }

        const $submitBtn = $('.call-scheduler-btn');
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text(isRescheduling ? 'Rescheduling...' : 'Scheduling...');

        $.ajax({
            url: url,
            method: 'POST',
            data: submitData,
            success: (response) => {
                formSubmitted = true;

                let displayDate;
                let dateTimeForDisplay;

                if (isRescheduling && currentAppointmentId) {
                    if (response.success) {
                        displayDate = formatDisplayDate($('#selected-date-field').val());
                        dateTimeForDisplay = `${displayDate} | ${$('#available-time-field').val()}`;
                        scheduledData = {
                            dateTime: dateTimeForDisplay,
                            id: currentAppointmentId,
                            productid: scheduledData ? scheduledData.productid : $('input[name="productID"]').val()
                        };
                    } else {
                        $submitBtn.prop('disabled', false).text(originalText);
                        return;
                    }
                } else {
                    displayDate = formatDisplayDate(response.formData.date);
                    dateTimeForDisplay = `${displayDate} | ${response.formData.timeSlot}`;

                    scheduledData = {
                        dateTime: dateTimeForDisplay,
                        id: response.formData.id,
                        productid: response.formData.productId
                    };

                    $('.video-call-cta').addClass('d-none');
                }

                $('.call-scheduler').addClass('d-none').hide();
                $('.scheduled-date-time').text(dateTimeForDisplay);
                $('.confirm-call-schedule').removeClass('d-none').show();

                $form.attr('data-id', scheduledData.id);
            },
            error: () => {
            },
            complete: () => {
                $submitBtn.prop('disabled', false).text(originalText);
            }
        });
    });

    $('#book-appointment-modal').on('hidden.bs.modal', () => {
        removeModalBackdrop();
        if (formSubmitted && scheduledData) {
            $('.video-reschedule-banner .scheduled-date-time').text(scheduledData.dateTime);
            $('.video-reschedule-banner .reschedule-btn').attr('data-id', scheduledData.id);
            $('.vc-section-right').addClass('d-none');
            $('.video-call-gif').addClass('d-none');
            $('.video-reschedule-banner').removeClass('d-none').show();
            formSubmitted = false;
        }
    });

    $(window).on('beforeunload', function () {
        removeModalBackdrop();
    });
});
